import { AppPaths } from "@p0security/shared/routes/constants";
import { AgenticClientsContext } from "components/Agentic/AgenticClientsContext";
import { delegateIconOf } from "components/Agentic/DelegationChain";
import { AgenticPaths } from "components/Agentic/paths";
import { TenantAwareLink } from "components/common/TenantAwareLink";
import React, { useContext } from "react";

import type { RequestAttribution } from "../Jit/Requests/types.ts";

// RequestAttribution's "agent" is always a client identity in delegateIconOf's
// own (richer) DelegateIdentity taxonomy, which is where its icons live.
const iconOf = (type: RequestAttribution["type"]) =>
  delegateIconOf({ type: type === "agent" ? "client" : "user" });

export const Identity = (props: {
  value: RequestAttribution;
  noLink?: boolean;
  className?: string;
  /** Shows an icon for the identity's type, next to the "via"/"on behalf
   * of" prefix a delegate or proxy role already adds. */
  withIcon?: boolean;
}): React.ReactNode => {
  const { noLink, className, value, withIcon = false } = props;
  const { clientsById } = useContext(AgenticClientsContext);
  const display = clientsById.get(value.sub)?.displayName ?? value.sub;
  const prefix =
    value.role === "delegate"
      ? "via "
      : value.role === "proxy"
        ? "on behalf of "
        : undefined;
  return (
    <>
      {prefix}
      {/* The icon accompanies the prefix itself; a bare principal (no
          prefix) has nothing for it to sit "after". */}
      {withIcon && prefix && <>{iconOf(value.type)} </>}
      {value.type === "user" ? (
        <span className={className}>{value.sub}</span>
      ) : value.type === "agent" ? (
        <span className={className}>
          {noLink ? (
            display
          ) : (
            <TenantAwareLink
              to={`${AppPaths.AgenticAccess}/${AgenticPaths.Clients}/${encodeURIComponent(value.sub)}`}
            >
              {display}
            </TenantAwareLink>
          )}
        </span>
      ) : (
        "(unknown)"
      )}
    </>
  );
};
